import React from 'react';

const IconLogo = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 84 96">
    <title>Logo</title>
    <g transform="translate(-8.000000, -2.000000)">
      <g transform="translate(11.000000, 5.000000)">
        <polygon
          points="66.04 28.08 62.24 34.66 47.11 60.87 43.3 67.46 39.5 74.05 35.7 67.46 39.5 60.87 43.3 54.27 54.63 34.66 47.02 34.66 39.5 47.68 31.98 34.66 24.37 34.66 35.7 54.27 31.89 60.87 16.76 34.66 12.96 28.08 66.04 28.08"
          fill="currentColor"
        />
        <polygon
          id="Shape"
          stroke="currentColor"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="39 0 0 22 0 67 39 90 78 68 78 23"
        />
      </g>
    </g>
  </svg>
);

export default IconLogo;
